import { render, staticRenderFns } from "./TrafficMessageRoutesText.vue?vue&type=template&id=11906f62"
import script from "./TrafficMessageRoutesText.vue?vue&type=script&lang=js"
export * from "./TrafficMessageRoutesText.vue?vue&type=script&lang=js"
import style0 from "./TrafficMessageRoutesText.vue?vue&type=style&index=0&id=11906f62&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports